import { TitleButtonDivider } from '@/common/buttons/TitleButtonDivider';
import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { MassOverwriteButton } from '@/common/entityFramework/entityPerspective/overwrite/MassOverwriteButton';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useRef } from 'react';
import { TheraSelect } from '../../../theraSelect/TheraSelect';

export const AbvChbkPipeOverUnderPerspective = ({ overUnderScenId }) => {
  const entityPerspectiveRef = useRef();
  const theraSelectRef = useRef();

  const entity = 'CHBK_PIPE_OVER_UNDER';

  const views = [
    {
      name: 'Full Breakout',
      dims: ['OVER_UNDER_SCEN', 'PROD'],
      kpis: [
        'ACTUALS_PYMT_AMT',
        'LBE_AMT',
        'PYMT_ADJ',
        'TOTAL_PYMT',
        'MONTHLY_PYMT',
        'MIN_MONTH',
        'MIDPOINT',
        'MAX_MONTH',
        'MONTHLY_MOVING_AVG_AT_LOW',
        'MONTHLY_MOVING_AVG_AT_MIDPOINT',
        'MONTHLY_MOVING_AVG_AT_HIGH',
        'END_PIPE_BAL',
        'LBE_PIPE_ADJ',
        'PROPOSED_PL_PIPE_ADJ',
        'TOTAL_PL_ADJ',
        'PROPOSED_BS_PIPE_RECLASS',
        'PROPOSED_BAL',
        'OVER_UNDER_LOW_AMT',
        'OVER_UNDER_AMT',
        'OVER_UNDER_HIGH_AMT',
      ],
      disabledDims: ['OVER_UNDER_SCEN'],
      numFrozenDims: 1,
    },
  ];

  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    let proposedAdjSubMenu = [
      {
        name: 'Balance Pipeline Reclass',
        action: () =>
          entityPerspectiveRef.current.navigateToPerspectiveAdj(
            params,
            'PROPOSED_BS_PIPE_RECLASS',
            'Proposed B/S Pipeline Reclass',
          ),
        icon: fas.faSlidersH,
      },
      {
        name: 'P/L Pipeline Adjustments',
        action: () =>
          entityPerspectiveRef.current.navigateToPerspectiveAdj(
            params,
            'PROPOSED_PL_PIPE_ADJ',
            'Proposed P/L Pipeline Adjustments',
          ),
        icon: fas.faSlidersH,
      },
    ];

    contextMenus.push(
      {
        name: 'Payment Adjustments',
        action: () => entityPerspectiveRef.current.navigateToPerspectiveAdj(params, 'PYMT_ADJ', 'Payment Adjustments'),
        icon: fas.faSlidersH,
      },
      {
        name: 'Proposed Adjustments',
        subMenu: proposedAdjSubMenu,
        icon: fas.faSlidersH,
      },
    );

    return contextMenus;
  };

  const defaultDimFilters = { OVER_UNDER_SCEN: [overUnderScenId] };

  const handleViewReset = useCallback(() => {
    theraSelectRef.current.reset();
  }, []);

  const events = {
    onDimFilterChange: ({ dimCode }) => {
      if (dimCode === 'PROD') {
        theraSelectRef.current.reset();
      }
    },
  };

  const augButtons = (buttons) => {
    buttons.unshift(
      <TheraSelect entityPerspectiveRef={entityPerspectiveRef} ref={theraSelectRef} />,
      <MassOverwriteButton
        toolTip={'Adjust Chargeback Pipeline Over/(Under)'}
        kpiCodes={['PYMT_ADJ', 'PROPOSED_BS_PIPE_RECLASS', 'PROPOSED_PL_PIPE_ADJ']}
        entity={entity}
        defaultDimValues={{ OVER_UNDER_SCEN: overUnderScenId }}
      />,
      <TitleButtonDivider key="filterButtonDivider" />,
    );
  };

  const augKpis = (kpi) => {
    if (kpi.code === 'OVER_UNDER_LOW_AMT') {
      kpi.cellStyle = (p) => (p.value < 0 ? { backgroundColor: '#fde2e2' } : undefined);
    }

    if (kpi.code === 'OVER_UNDER_HIGH_AMT') {
      kpi.cellStyle = (p) => (p.value > 0 ? { backgroundColor: '#fde2e2' } : undefined);
    }
  };

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      entity={entity}
      augKpis={augKpis}
      defaultDimFilters={defaultDimFilters}
      onViewReset={handleViewReset}
      augButtons={augButtons}
      events={events}
      views={views}
      gridOptions={{
        getContextMenuItems,
      }}
    />
  );
};
